import { render, staticRenderFns } from "./UserOldAddressTable.vue?vue&type=template&id=1918abb7&"
import script from "./UserOldAddressTable.vue?vue&type=script&lang=ts&"
export * from "./UserOldAddressTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
